/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RoutingPredicateOp } from './routingPredicateOp';

export interface RoutingPredicate {
  /**
     * @minLength 1
     * @maxLength 40
     */
  key: string;
  op: RoutingPredicateOp;
  value: string | string[];
}
